import cn from "classnames";
import { forwardRef } from "react";
import { A11yChild } from "../../../../a11y";
import { Checkbox } from "../../../../checkbox";
import { OptionLabel } from "./option-label";
import { OptionProps } from "./types";
import styles from "./styles.module.scss";

export const Option = forwardRef<HTMLLIElement, OptionProps>(
  (
    {
      id,
      index,
      option,
      dataTestId,
      searchable,
      searchValue,
      showCheckbox,
      hasA11yFocus,
      a11yChildRef,
      onClick,
    },
    ref
  ) => {
    const {
      label,
      content,
      additionalLabel,
      checked = false,
      disabled = false,
      value,
      ...rpTrackerAttributes
    } = option;

    return (
      <A11yChild
        hasA11yFocus={hasA11yFocus}
        a11yChildRef={a11yChildRef}
        ref={ref}
      >
        <li
          {...rpTrackerAttributes}
          id={id}
          role="option"
          onClick={onClick}
          aria-selected={hasA11yFocus}
          aria-disabled={disabled}
          data-test-id={dataTestId}
          className={cn(styles.option, {
            [styles.disabled]: disabled,
            [styles["has-a11y-focus"]]: hasA11yFocus,
          })}
          data-index={index}
        >
          {showCheckbox && (
            <Checkbox
              checked={checked}
              disabled={disabled}
              className={cn(styles.checkbox, { [styles.disabled]: disabled })}
            />
          )}

          <div className={styles.label}>
            <OptionLabel
              label={label}
              content={content}
              checked={checked}
              showCheckbox={showCheckbox}
              disabled={disabled}
              searchable={searchable}
              searchValue={searchValue}
              dataTestId={dataTestId}
            />
          </div>

          {!content && additionalLabel && (
            <div
              className={cn(styles["additional-label"], {
                [styles.disabled]: disabled,
              })}
            >
              {additionalLabel}
            </div>
          )}
        </li>
      </A11yChild>
    );
  }
);
